import type { Reducer } from 'redux';

import type { SetPersistKeyAction } from '../../domains/persistConfig/actions.types';

import type { PersistConfig } from './types';

export type PersistConfigAction = SetPersistKeyAction;

const initialState: PersistConfig = { key: undefined };

const reducer: Reducer<PersistConfig, PersistConfigAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'PERSIST_KEY.SET':
      return { key: action.payload.key };
    default:
      return state;
  }
};

export default reducer;
